import { render, staticRenderFns } from "./UserIcon.vue?vue&type=template&id=14e2b98d&scoped=true&"
import script from "./UserIcon.vue?vue&type=script&lang=ts&"
export * from "./UserIcon.vue?vue&type=script&lang=ts&"
import style0 from "./UserIcon.vue?vue&type=style&index=0&id=14e2b98d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e2b98d",
  null
  
)

export default component.exports